// Module
var code = ` <div class="filters">

    <!-- Branch -->
    <div class="labelled-field labelled-field--long">
      <label for="filter-branch" class="add-on">Branch</label>
      <select id="filter-branch"
              class="form-control"
              ng-disabled="\$ctrl.availableBranches && \$ctrl.availableBranches.length === 1"
              ng-model="\$ctrl.filter.branchId"
              ng-options="branch.id as branch.name for branch in \$ctrl.availableBranches">
        <option value="" ng-if="\$ctrl.availableBranches && \$ctrl.availableBranches.length > 1">(All branches)</option>
      </select>

    </div>

    <!-- Status -->
    <div class="labelled-field labelled-field--long">
      <label for="filter-status" class="add-on">Status</label>
      <select id="filter-status"
              class="form-control"
              ng-model="\$ctrl.filter.status"
              ng-options="status | prettyEnum for status in \$ctrl.checkStatuses">
        <option value="">(All statuses)</option>
      </select>
    </div>

    <!-- Check registration date -->
    <date-range-picker model="\$ctrl.filter.dateRange"></date-range-picker>

    <!-- Actions -->
    <button ng-click="\$ctrl.onFilterBtnClicked()" class="btn btn-primary btn--filter">
      Filter
    </button>

     <div class="button-container">
       <button command-access="RegisterInwardCheck" ng-click="\$ctrl.postManualCheck()" class="btn btn-outline">
         Post manual check
       </button>
       <button command-access="BatchRegisterInwardCheck" ng-click="\$ctrl.batchRegisterChecks()" class="btn btn-outline">
         Batch register checks
       </button>
     </div>

  </div>

  <div class="tab-content">
    <div class="tab-pane" id="tab-outgoing-checks" ng-class="{'active': true}">
      <div ng-if="\$ctrl.checks && \$ctrl.checks.length > 0">
        <table class="table" ng-table="\$ctrl.tableConfig">
          <tbody class="appraisal-details">
          <tr ng-repeat-start="item in \$ctrl.checks"
              class="table__row--clickable"
              ng-click="\$ctrl.itemClicked(item, \$event)"
              ng-class="{'selected': \$ctrl.selectedCheckId === item.id}">
            <td data-title="'No'">
              {{\$index+1 + (\$ctrl.tableConfig.page() - 1) * \$ctrl.tableConfig.count()}}
            </td>

            <td data-title="'Number'">{{item.number }}</td>
            <td data-title="'MICR'">{{item.micrNumber }}</td>
            <td data-title="'Product number'">{{item.productNumber}}</td>
            <td data-title="'Status'">{{item.status | prettyEnum }}</td>
            <td data-title="'Amount'">{{item.amount | nxCurrency }}</td>
            <td data-title="'Clearing group'">{{item.checkClearingGroup | prettyEnum }}</td>
            <td data-title="'Registered on'">{{item.registeredOn | prettyDate }}</td>
          </tr>

          <tr ng-repeat-end class="table__row--not-hoverable">
            <td colspan="100%">
              <div class="toggleable-panel-wrapper"
                   ng-class="{'toggleable-panel-wrapper--toggled': \$ctrl.selectedCheckId === item.id}">
                <inline-panel on-hide="\$ctrl.hideInlinePanel()">
                  <div class="inline-panel__list">
                    <div class="inline-panel__container" ng-repeat="detail in \$ctrl.selectedCheck.details">
                      <label class="inline-panel__label">{{detail.label}}:</label>
                      <p class="inline-panel__value">{{detail.value}}</p>
                    </div>
                  </div>
                  <div class="inline-panel-footer">
                    <button class="btn btn-primary action-button" type="button"
                            ng-show="\$ctrl.selectedCheck.canBeValidated"
                            ng-click="\$ctrl.validate(\$ctrl.selectedCheck)">
                      Validate
                    </button>
                    <button class="btn btn-success action-button" type="button"
                            ng-show="\$ctrl.selectedCheck.canBeCleared"
                            ng-click="\$ctrl.clear(\$ctrl.selectedCheck)">
                      Clear
                    </button>
                    <button class="btn btn-danger action-button" type="button"
                            command-access="CancelInwardCheck"
                            ng-if="\$ctrl.selectedCheck.canBeCancelled"
                            ng-click="\$ctrl.cancel(\$ctrl.selectedCheck)">
                      Cancel
                    </button>
                    <button class="btn btn-info action-button" type="button"
                            ng-click="\$ctrl.goToAccount(\$ctrl.selectedCheck)">
                      Open account
                    </button>
                  </div>
                </inline-panel>
              </div>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <div ng-if="\$ctrl.checks == null || \$ctrl.checks.length === 0" class="empty-message">
    <span>No checks matching given criteria found</span>
  </div>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/inventory/check/outgoing/outgoing-checks-list.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;